import { isEqual } from 'lodash-es'

import {
  SortFilterTraitFilter,
  SortFilterTraitSort,
} from '../../types/sort-filter-trait'

export const cleanExternalFilters = ({
  filters,
  filterFieldsToFilterAgainst,
}: {
  filterFieldsToFilterAgainst: SortFilterTraitFilter['field'][]
  filters: SortFilterTraitFilter[]
}): SortFilterTraitFilter[] => {
  return filters.filter((filter) => {
    return filterFieldsToFilterAgainst.includes(filter.field)
  })
}

export const cleanExternalSorts = ({
  sorts,
  sortKeysToFilterAgainst,
}: {
  sortKeysToFilterAgainst: SortFilterTraitSort['field'][]
  sorts: SortFilterTraitSort[]
}): SortFilterTraitSort[] => {
  const result = sorts.filter((sort) => {
    return sortKeysToFilterAgainst.some((sortKey) => {
      return isEqual(sortKey, sort.field)
    })
  })

  return result
}
